/**
 * Utility to preload components
 *
 * This module helps optimize performance by preloading components
 * before they're needed, reducing perceived loading times for users.
 */

let productVideoPreloaded = false;
let orderStatusPreloaded = false;

/**
 * Preloads the ProductVideo component if it hasn't been preloaded already
 * This improves performance by loading the video component in advance
 * when a user is likely to view a product with video
 */
export function preloadProductVideo() {
    if (!productVideoPreloaded) {
        import('../components/elements/ProductVideo');
        productVideoPreloaded = true;
    }
}

/**
 * Preloads the OrderStatus component if it hasn't been preloaded already
 * This improves performance by loading the component in advance
 * when a user is in the checkout process
 */
export function preloadOrderStatus() {
    if (!orderStatusPreloaded) {
        import('@/views/OrderStatus');
        orderStatusPreloaded = true;
    }
}
